import { GlobalContextProvider } from 'context';
import { MODULES_BASENAME } from 'module-routes';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import ScrollToTop from 'shared/components/ScrollToTop/ScrollToTop';
import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <Router basename={MODULES_BASENAME}>
    <ScrollToTop />
    <GlobalContextProvider>
      <App />
    </GlobalContextProvider>
  </Router>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
